/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_Enter_Current_PasswordInputs */

const en_common_enter_current_password = /** @type {(inputs: Common_Enter_Current_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enter current password`)
};

const es_common_enter_current_password = /** @type {(inputs: Common_Enter_Current_PasswordInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Ingresa la contraseña actual`)
};

/**
* | output |
* | --- |
* | "Enter current password" |
*
* @param {Common_Enter_Current_PasswordInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_enter_current_password = /** @type {((inputs?: Common_Enter_Current_PasswordInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_Enter_Current_PasswordInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_enter_current_password(inputs)
	return en_common_enter_current_password(inputs)
});